<!-- USAGE:
<custom-modal
id="modal1"
v-model="modals['modal1']"
modal-class="custom-modal"
header-class="custom-header"
body-class="custom-body"
footer-class="custom-footer"
@close="onModalClose"
@close-modal="onCustomClose"
>
<template v-slot:modalHeader>
<p>This is some header</p>
</template>
<template v-slot:modalBody>
<p>This is Modal 1 content.</p>
</template>
<template v-slot:modalFooter>
<v-btn color="secondary" @click="modals['modal1'] = false">Cancel</v-btn>
<v-btn color="primary" @click="doSomething">Confirm</v-btn>
</template>
</custom-modal>

data(){
return {
  modals: {
   modal1: false,
},
}
methods: {
    openModal(id) {
      this.$set(this.modals, id, true);
    },
    onModalClose(id) {
      console.log(`Modal ${id} closed`);
    },
    onCustomClose(id) {
      console.log(`Custom close event for modal ${id}`);
    },
    doSomething() {
      console.log('Button Action');
      this.modals['modal1'] = false;
    }
}
-->

<template>
  <v-dialog
    :modelValue="isOpen"
    :max-width="maxWidth"
    @update:modelValue="onClose"
    @keydown.esc="handleModalCloseCross"
  >
    <div :class="['modal-container', modalClass]" :style="modalStyle" style="overflow-y: auto">
      <!-- Modal Header -->
      <div :class="['modal-header', headerClass]" :style="headerStyle">
        <slot name="modalHeader" />
        <v-spacer />
        <v-icon @click="handleModalCloseCross">mdi-close</v-icon>
      </div>

      <!-- Modal Body -->
      <div :class="['modal-body', bodyClass]" :style="bodyStyle">
        <slot name="modalBody" />
      </div>

      <!-- Modal Footer -->
      <div v-if="$slots.modalFooter" :class="['modal-footer', footerClass]" :style="footerStyle">
        <slot name="modalFooter" />
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['update:modelValue', 'close', 'close-modal'],
  name: 'CustomModal',

  props: {
    id: {
      type: String,
      required: true
    },
    modelValue: {
      type: Boolean,
      required: true
    },

    modalClass: {
      type: String,
      default: ''
    },
    modalStyle: {
      type: Object,
      default: () => ({})
    },
    headerClass: {
      type: String,
      default: ''
    },
    headerStyle: {
      type: Object,
      default: () => ({})
    },
    bodyClass: {
      type: String,
      default: ''
    },
    bodyStyle: {
      type: Object,
      default: () => ({})
    },
    footerClass: {
      type: String,
      default: ''
    },
    footerStyle: {
      type: Object,
      default: () => ({})
    },
    maxWidth: {
      type: Number,
      default: 720
    }
  },

  computed: {
    isOpen: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    }
  },

  created() {
    // Adding this event for capturing the custom modal close from external pages or components
    this.closeModalHandler = (id) => {
      if (id === this.id) {
        this.handleModalCloseCross();
      }
    };

    // Use the global event emitter instead of $root
    if (this.$eventBus) {
      this.$eventBus.on('close-custom-modal', this.closeModalHandler);
    }
  },

  beforeUnmount() {
    if (this.$eventBus) {
      this.$eventBus.off('close-custom-modal', this.closeModalHandler);
    }
  },

  methods: {
    handleModalCloseCross() {
      this.$emit('close', this.id);
      this.isOpen = false;
    },
    emitCloseModal() {
      this.$emit('close-modal', this.id);
      this.isOpen = false;
    },
    onClose(val) {
      if (!val) this.$emit('close', this.id);
    }
  }
});
</script>

<style lang="scss" scoped>
.modal-container {
  background-color: white;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
}

.modal-body {
  // border: none;
}

.modal-footer {
  // border: none;
}
</style>
